export default "__VITE_ASSET__DYYOSYlV__"